<template>
  <div class="space-y-5">
    <div @keydown="onKeyDown" @keyup="onKeyUp">
      <search-bar
        name="searchSheet"
        libelle=""
        :value="searchSheet"
        placeholder="Rechercher une fiche de poste"
        :big="false"
        @input="
          (newValue) => {
            searchSheet = newValue;
          }
        "
      />
    </div>
    <div class="flex w-full justify-center">
      <div
        v-if="isLoading"
        class="animate-spin w-5 h-5 border-t border-b rounded-full border-gray-900"
      />
    </div>
    <list-grid
      :list-items="sheets"
      :is-listdisplayed="sheets != null && sheets.length > 0"
      :is-accordion-items="true"
      @displayNum="
        (numToDisplay) => {
          sheetNumToDisplay = numToDisplay;
        }
      "
    >
      <template #header v-if="sheets">
        <div class="hidden md:block pl-15 col-span-3">Sélectionner</div>
        <div class="md:hidden col-span-3 text-center">Sél.</div>
        <div class="col-span-9">Fiche de poste</div>
      </template>

      <template #errorCases>
        <div
          v-if="sheets && sheets.length === 0"
          class="flex flex-col justify-center items-center w-full my-8"
        >
          <div class="text-pink-600 text-center text-lg mb-8">
            Aucune fiche de poste !
          </div>
          <div class="text-indigo-600 text-center text-base mb-8">
            Il n'y a aucune fiche de poste trouvée
          </div>
          <div>
            <illustration name="no_result" />
          </div>
        </div>
      </template>

      <!-- BEGIN list of fiche de poste -->
      <template #accordionDescription="{ item, num }">
        <div
          class="col-span-3 md:pl-15 flex justify-center md:block md:justify-start"
        >
          <checkbox-indigo
            :name="'selectSheet' + item.id"
            :value="isSheetSelected(item)"
            :has-partly="filter.some((f) => f.sheet.id === item.id)"
            @input="
              (newValue) => {
                selectSheet(item, newValue);
              }
            "
            class="w-max"
          />
        </div>
        <div class="col-span-9 grid grid-cols-12 space-x-1 items-center">
          <p class="col-span-10">
            {{ item.name }}
          </p>
          <div class="col-span-2 flex justify-center">
            <icon
              name="chevron-right"
              class="text-pink-600 transform duration-300 rotate-0"
              :class="{ 'rotate-90': sheetNumToDisplay === num }"
            />
          </div>
        </div>
      </template>

      <template #accordionContent="{ item, num }">
        <!-- List of sheet activities -->
        <div
          v-for="(activity, numAct) in item.data.activities"
          :key="'activity' + item.id + numAct"
          class="odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
          style="padding: 0px !important"
        >
          <div
            @click.stop="displayActivity(num, numAct)"
            class="py-5 grid grid-cols-12 gap-x-4 gap-y-10 items-center place-content-center cursor-default hover:bg-indigo-200"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                activityDisplayed.numSheet === num &&
                activityDisplayed.numActivity === numAct,
            }"
          >
            <div
              class="col-span-3 md:pl-15 flex justify-center md:block md:justify-start"
            >
              <checkbox-indigo
                :name="'selectActivity' + item.id + numAct"
                :value="isActivitySelected(item, numAct)"
                :has-partly="
                  filter.some(
                    (f) => f.sheet.id === item.id && f.activity === numAct
                  )
                "
                @input="
                  (newValue) => {
                    selectActivity(item, numAct, newValue);
                  }
                "
                class="w-max"
              />
            </div>
            <div class="col-span-9 grid grid-cols-12 space-x-1 items-center">
              <p class="col-span-10">
                {{ activity.activity_name }}
              </p>
              <div class="col-span-2 flex justify-center">
                <icon
                  name="chevron-right"
                  class="text-pink-600 transform duration-300 rotate-0"
                  :class="{
                    'rotate-90':
                      activityDisplayed.numSheet === num &&
                      activityDisplayed.numActivity === numAct,
                  }"
                />
              </div>
            </div>
          </div>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-show="
                activityDisplayed.numSheet === num &&
                activityDisplayed.numActivity === numAct
              "
              class="bg-white pl-10 py-5"
            >
              <!-- List of activity competences -->
              <div
                v-for="typeComp in [
                  'activity_tasks',
                  'activity_pratiques_pros',
                  'activity_connaissances',
                  'activity_comportements',
                ]"
                :key="'typeComp' + item.id + numAct + typeComp"
                class="odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
                style="padding: 0px !important"
              >
                <div
                  @click.stop="displayTypeCompetence(num, numAct, typeComp)"
                  class="py-5 grid grid-cols-12 gap-x-4 gap-y-10 items-center place-content-center cursor-default hover:bg-indigo-200"
                  :class="{
                    'bg-indigo-200 border-l-2 border-indigo-600':
                      typeCompetenceDisplayed.numSheet === num &&
                      typeCompetenceDisplayed.numActivity === numAct &&
                      typeCompetenceDisplayed.typeComp === typeComp,
                  }"
                >
                  <div
                    class="col-span-3 md:pl-15 flex justify-center md:block md:justify-start"
                  >
                    <checkbox-indigo
                      :name="'selectTypeComp' + item.id + numAct + typeComp"
                      :value="isTypeCompetenceSelected(item, numAct, typeComp)"
                      :has-partly="
                        filter.some(
                          (f) =>
                            f.sheet.id === item.id &&
                            f.activity === numAct &&
                            f.type === typeComp
                        )
                      "
                      @input="
                        (newValue) => {
                          selectTypeCompetence(
                            item,
                            numAct,
                            typeComp,
                            newValue
                          );
                        }
                      "
                      class="w-max"
                    />
                  </div>
                  <div
                    class="col-span-9 grid grid-cols-12 space-x-1 items-center"
                  >
                    <p class="col-span-10">
                      {{ getLibelleTypeCompetencePro(typeComp) }}
                    </p>
                    <div class="col-span-2 flex justify-center">
                      <icon
                        name="chevron-right"
                        class="text-pink-600 transform duration-300 rotate-0"
                        :class="{
                          'rotate-90':
                            typeCompetenceDisplayed.numSheet === num &&
                            typeCompetenceDisplayed.numActivity === numAct &&
                            typeCompetenceDisplayed.typeComp === typeComp,
                        }"
                      />
                    </div>
                  </div>
                </div>
                <transition
                  enter-active-class="ease-out duration-300"
                  enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-active-class="ease-in duration-200"
                  leave-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <div
                    v-show="
                      typeCompetenceDisplayed.numSheet === num &&
                      typeCompetenceDisplayed.numActivity === numAct &&
                      typeCompetenceDisplayed.typeComp === typeComp
                    "
                    class="bg-white pl-10 py-5"
                  >
                    <!-- list of sheet competence in type competence -->
                    <div
                      v-for="(competence, numComp) in item.data.activities[
                        numAct
                      ][typeComp]"
                      :key="
                        'sheetCompetence' +
                        item.id +
                        numAct +
                        typeComp +
                        numComp
                      "
                      class="odd:bg-indigo-100 odd:bg-opacity-50 bg-white"
                      style="padding: 0px !important"
                    >
                      <div
                        class="py-5 grid grid-cols-12 gap-x-4 gap-y-10 items-center place-content-center cursor-default hover:bg-indigo-200"
                      >
                        <div
                          class="col-span-3 md:pl-15 flex justify-center md:block md:justify-start"
                        >
                          <checkbox-indigo
                            :name="
                              'selectComp' +
                              item.id +
                              numAct +
                              typeComp +
                              numComp
                            "
                            :value="
                              isCompetenceSelected(
                                item,
                                numAct,
                                typeComp,
                                numComp
                              )
                            "
                            @input="
                              (newValue) => {
                                selectCompetence(
                                  item,
                                  numAct,
                                  typeComp,
                                  numComp,
                                  newValue
                                );
                              }
                            "
                            class="w-max"
                          />
                        </div>
                        <div class="col-span-9">
                          {{ competence.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </template>
    </list-grid>
    <!-- BEGIN Links for pagination -->
    <div
      v-if="sheets.length > 0"
      class="w-full flex items-center justify-center"
    >
      <div class="w-full md:w-1/2 flex items-center justify-center space-x-5">
        <div @click.stop="getToPreviousPage">
          <icon
            name="chevron-left"
            class="p-2 w-8 h-8 rounded-full"
            :class="{
              'bg-gray-600 text-white': selectedPage === 1,
              'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300':
                selectedPage !== 1,
            }"
          />
        </div>
        <div class="flex flex-wrap items-center justify-center w-full">
          <div
            class="p-3 w-8 h-8 rounded-full flex justify-center items-center cursor-pointer transform hover:scale-110 duration-300"
            :class="{
              'bg-pink-600 text-white': pageNumber === selectedPage,
            }"
            v-for="pageNumber in pages"
            :key="'pageNumber' + pageNumber"
            @click="selectedPage = pageNumber"
          >
            {{ pageNumber }}
          </div>
        </div>
        <div @click.stop="getToNextPage">
          <icon
            name="chevron-right"
            class="p-2 w-8 h-8 rounded-full"
            :class="{
              'bg-gray-600 text-white': selectedPage == lastPage,
              'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300':
                selectedPage != lastPage,
            }"
          />
        </div>
      </div>
    </div>
    <!-- END Links for pagination -->
  </div>
</template>

<script>
import axios from './../../../../api';
import ListGrid from '../../../../components/AccordionTable/ListGrid.vue';
import CheckboxIndigo from '../../../../components/Inputs/CheckboxIndigo.vue';
import Icon from '../../../../components/Icon.vue';
import SearchBar from '../../../../components/Inputs/SearchBar.vue';
import Illustration from '../../../../components/Illustration.vue';

export default {
  components: {
    ListGrid,
    CheckboxIndigo,
    Icon,
    SearchBar,
    Illustration,
  },

  props: {
    filter: Array,
  },

  data() {
    return {
      listSheets: [],
      searchSheet: '',
      sheetNumToDisplay: -1,
      activityDisplayed: { numSheet: -1, numActivity: -1 },
      typeCompetenceDisplayed: { numSheet: -1, numActivity: -1, typeComp: '' },
      selectedPage: 1,
      lastPage: 1,
      totalNbBeneficiaries: 0,
      isLoading: false,
      searchTypingInterval: 500,
    };
  },

  mounted() {
    this.loadSheetsList();
  },

  methods: {
    onKeyDown() {
      clearTimeout(this.timer);
    },

    onKeyUp() {
      clearTimeout(this.timer);
      this.timer = setTimeout(
        // if selectedPage already at 1, then, watched property never release
        this.selectedPage === 1
          ? this.loadSheetsList()
          : (this.selectedPage = 1),
        this.searchTypingInterval
      );
    },

    async loadSheetsList() {
      console.log('wait..Module competences load sheets');

      this.isLoading = true;

      try {
        await axios
          .post(
            'api/sheets/listByType/job_desc?paginated=0&page=' +
              this.selectedPage,
            {
              search: this.searchSheet,
              sector: '',
              family: '',
              orderBy: 'name',
              direction: 'ASC',
              wantEvaluationUsed: false,
              resource: 'Neopass',
            }
          )
          .then((response) => {
            let datas = response.data;
            this.listSheets = datas.sheets;
            this.lastPage = datas.lastPage;
            this.totalNbBeneficiaries = datas.total;
            this.isLoading = false;
          });
      } catch (err) {
        console.error('ERROR::', err);
        this.isLoading = false;
      }
    },

    selectSheet(sheet, isSelected) {
      this.$emit('selectSheet', { sheet: sheet, isSelected: isSelected });
    },
    selectActivity(sheet, numActivity, isSelected) {
      this.$emit('selectActivity', {
        sheet: sheet,
        numActivity: parseInt(numActivity),
        isSelected: isSelected,
      });
    },
    selectTypeCompetence(sheet, numActivity, typeCompetence, isSelected) {
      this.$emit('selectTypeCompetence', {
        sheet: sheet,
        numActivity: parseInt(numActivity),
        typeCompetence: typeCompetence,
        isSelected: isSelected,
      });
    },
    selectCompetence(
      sheet,
      numActivity,
      typeCompetence,
      numCompetence,
      isSelected
    ) {
      this.$emit('selectCompetence', {
        sheet: sheet,
        numActivity: parseInt(numActivity),
        typeCompetence: typeCompetence,
        competence: parseInt(numCompetence),
        isSelected: isSelected,
      });
    },

    isSheetSelected(sheet) {
      if (sheet.type != 'job_desc') return;
      let nbCompTotalInSheet = sheet.data.activities.reduce(
        (acc, activity) =>
          acc +
          activity.activity_tasks.length +
          activity.activity_pratiques_pros.length +
          activity.activity_connaissances.length +
          activity.activity_comportements.length,
        0
      );

      return nbCompTotalInSheet === 0 // don't select it if no competence
        ? false
        : this.filter.filter((comp) => comp.sheet.id === sheet.id).length ===
            nbCompTotalInSheet;
    },

    isActivitySelected(sheet, numActivity) {
      let activity = sheet.data.activities[numActivity];
      let nbCompTotalInActivity =
        activity.activity_tasks.length +
        activity.activity_pratiques_pros.length +
        activity.activity_connaissances.length +
        activity.activity_comportements.length;

      return nbCompTotalInActivity === 0
        ? false
        : this.filter.filter(
            (comp) =>
              comp.sheet.id === sheet.id &&
              comp.activity === parseInt(numActivity)
          ).length === nbCompTotalInActivity;
    },

    displayActivity(numSheet, numActivity) {
      if (
        this.activityDisplayed.numSheet === numSheet &&
        this.activityDisplayed.numActivity === numActivity
      ) {
        this.activityDisplayed.numSheet = -1;
        this.activityDisplayed.numActivity = -1;
        return;
      }
      this.activityDisplayed.numSheet = numSheet;
      this.activityDisplayed.numActivity = numActivity;
    },

    isTypeCompetenceSelected(sheet, numActivity, typeCompetence) {
      let activity = sheet.data.activities[numActivity];
      let nbCompTotalInTypeCompetence = activity[typeCompetence].length;

      return nbCompTotalInTypeCompetence === 0
        ? false
        : this.filter.filter(
            (comp) =>
              comp.sheet.id === sheet.id &&
              comp.activity === parseInt(numActivity) &&
              comp.type === typeCompetence
          ).length === nbCompTotalInTypeCompetence;
    },

    displayTypeCompetence(numSheet, numActivity, typeComp) {
      if (
        this.typeCompetenceDisplayed.numSheet === numSheet &&
        this.typeCompetenceDisplayed.numActivity === numActivity &&
        this.typeCompetenceDisplayed.typeComp === typeComp
      ) {
        this.typeCompetenceDisplayed.numSheet = -1;
        this.typeCompetenceDisplayed.numActivity = -1;
        this.typeCompetenceDisplayed.typeComp = '';
        return;
      }
      this.typeCompetenceDisplayed.numSheet = numSheet;
      this.typeCompetenceDisplayed.numActivity = numActivity;
      this.typeCompetenceDisplayed.typeComp = typeComp;
    },

    isCompetenceSelected(sheet, numActivity, typeCompetence, numCompetence) {
      return this.filter.some(
        (comp) =>
          comp.sheet.id === sheet.id &&
          comp.activity === parseInt(numActivity) &&
          comp.type === typeCompetence &&
          comp.competence === parseInt(numCompetence)
      );
    },

    getLibelleTypeCompetencePro(type) {
      switch (type) {
        case 'activity_tasks':
          return 'Tâches principales';
        case 'activity_pratiques_pros':
          return 'Pratiques professionnelles';
        case 'activity_connaissances':
          return 'Connaissances associées';
        case 'activity_comportements':
          return 'Comportements / Attitudes';
        default:
          return '';
      }
    },

    getToPreviousPage() {
      if (this.selectedPage === 1) {
        return;
      }

      this.selectedPage = this.selectedPage - 1;
    },

    getToNextPage() {
      if (this.selectedPage === this.lastPage) {
        return;
      }

      this.selectedPage = this.selectedPage + 1;
    },
  },

  computed: {
    sheets() {
      return this.listSheets.filter((sheet) => sheet.type === 'job_desc');
    },

    pages() {
      let pages = [];

      for (let index = 1; index <= this.lastPage; index++) {
        pages.push(index);
      }
      return pages;
    },
  },

  watch: {
    selectedPage() {
      this.loadSheetsList();
    },
  },
};
</script>
